import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppReleaseService } from '../../../core/services/app-release.service';
import { OdinConnectionStatus, OdinService } from '../../../core/services/odin.service';
import { PATCH_NOTES_URL } from '../../../shared/constants/app-release';

@Component({
  selector: 'andor-app-update-notice',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './app-update-notice.html',
  styleUrl: './app-update-notice.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateNotice {
  readonly release = inject(AppReleaseService);
  private readonly odin = inject(OdinService);
  private readonly document = inject(DOCUMENT);
  readonly patchNotesUrl = PATCH_NOTES_URL;
  readonly canReload = computed(
    () => this.odin.status() === OdinConnectionStatus.disconnected && !this.odin.pendingApproval()
  );

  reload() {
    if (this.release.availableRelease() && this.canReload()) {
      this.document.defaultView?.location.reload();
    }
  }
}
